import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "code"]

  connect() {
    // Find all code blocks and add copy buttons
    const codeBlocks = document.querySelectorAll("pre.highlight")

    codeBlocks.forEach((codeBlock) => {
      // Skip if button already exists
      if (codeBlock.querySelector(".copy-code-button")) {
        return
      }

      // Create copy button
      const button = document.createElement("button")
      button.className = "copy-code-button"
      button.setAttribute("data-action", "click->clipboard#copy")
      button.setAttribute("aria-label", "Copy code to clipboard")
      button.innerHTML = `
        <svg class="copy-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M5.5 3.5h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z"/>
          <path d="M3.5 5.5h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1"/>
        </svg>
        <svg class="check-icon hidden" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M13.5 4.5l-6 6-3-3"/>
        </svg>
      `

      // Make code block relative for positioning
      codeBlock.style.position = "relative"

      // Insert button
      codeBlock.appendChild(button)
    })
  }

  copy(event) {
    const button = event.currentTarget
    const codeBlock = button.closest("pre.highlight")
    const code = codeBlock.querySelector("code")

    if (!code) return

    // Get text content
    const text = code.textContent || code.innerText

    // Copy to clipboard
    navigator.clipboard.writeText(text).then(() => {
      // Show success state
      const copyIcon = button.querySelector(".copy-icon")
      const checkIcon = button.querySelector(".check-icon")

      copyIcon.classList.add("hidden")
      checkIcon.classList.remove("hidden")
      button.setAttribute("aria-label", "Copied!")

      // Reset after 2 seconds
      setTimeout(() => {
        copyIcon.classList.remove("hidden")
        checkIcon.classList.add("hidden")
        button.setAttribute("aria-label", "Copy code to clipboard")
      }, 2000)
    }).catch((err) => {
      console.error("Failed to copy:", err)
      // Fallback for older browsers
      const textArea = document.createElement("textarea")
      textArea.value = text
      textArea.style.position = "fixed"
      textArea.style.opacity = "0"
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand("copy")
        button.setAttribute("aria-label", "Copied!")
        setTimeout(() => {
          button.setAttribute("aria-label", "Copy code to clipboard")
        }, 2000)
      } catch (err) {
        console.error("Fallback copy failed:", err)
      }
      document.body.removeChild(textArea)
    })
  }
}

